<template>
  <div>
    <v-card>
      <v-snackbar v-model="snackbar" color="error" top centered timeout="8000">
        Selecione os itens que deseja imprimir antes de continuar!
      </v-snackbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-model="linhasSelecionadas"
        show-select
        :item-key="itemKey"
        :single-select="false"
        :headers="tableHeader"
        :items="tableRows"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="newRowmodalButtonText" @click="emitDataTableNewRowEvent">{{newRowmodalButtonText}}</v-btn>
            <v-btn
              v-if="printButtonName"
              class="ml-5"
              :disabled="dialog"
              :loading="dialog"
              @click="emitPrintEstoque(linhasSelecionadas)"
            >
              <v-icon left dark>
                mdi-printer
              </v-icon>
              {{printButtonName}}
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.validade`]="{ item }"> <!--- Trecho específico para tratamento do tipo tarefa --->
            <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
        </template>

        <template v-slot:[`item.item.validade`]="{ item }"> <!--- Trecho específico para tratamento do tipo tarefa --->
            <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
        </template>

        <template v-slot:[`item.item.indicadorStatusFamilia`]="{ item }"> <!--- Trecho específico para tratamento do tipo tarefa --->
           {{formataFamilia(item.item.indicadorStatusFamilia)}}
        </template>

        <template v-slot:[`item.actions`]="{item}">
          <v-tooltip v-if="item.indicadorStatus != 8 && isView " bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableViewRowEvent(item)" v-bind="attrs" v-on="on">mdi-eye</v-icon>
            </template>
            <span>Visualizar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// import axios from "../plugins/axios";
import store from "@/store/index";
// import { Workbook } from "exceljs";
// import { saveAs } from "file-saver";

export default {
  props: {
    tableTitle: String,
    newRowmodalButtonText: String,
    printButtonName: String,
    tableHeader: Array,
    tableRows: Array,
    itemKey: String,
    isEdit: Boolean,
    isView: Boolean,
    isStatus: Boolean,
    isFinish: Boolean,
    isDel: Boolean,
    isDevolucao: Boolean,
    isPrint: Boolean,
    isExcel: Boolean,
    isContext: Boolean,
    isConfirmMaterial: Boolean
  },

  data: function() {
    return {
      search: "",
      snackbar: false,
      linhasSelecionadas: [],
      dialog: false,

      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
    };
  },

  methods: {
    // EMITS
    emitPrintEstoque(row) {
      if(row.length > 0) {
        this.snackbar = false
        this.$emit("datatable-print", row);
      } else {
        this.snackbar = true
      }
    },

    emitDataTableViewRowEvent(row){
      this.$emit("datatable-viewrow", row)
    },

    emitDataTableNewRowEvent() {
      this.$emit("datatable-newrow");
    },

    formataFamilia(indicador) {
      switch (indicador) {
        case null: return "Não vinculado"
        case 0: return "Não vinculado"
        case 1: return "Medicações"
        case 2: return "Materiais"
        case 3: return "Psicotrópicos"
        case 4: return "Saneantes"
        case 5: return "Cosméticos"
        case 6: return "Nutrição"
        case 7: return "Antimicrobianos"
        case 8: return "Amostra Grátis"
        case 9: return "Maleta de Emergência"
        case 10: return "Doação"
        case 11: return "Teste Rápido"
        case 12: return "USO INTERNO"
      }
    },

    corValidade(data) {
      if(data) {
        var ano  = data.split("/")[2];
        var mes  = data.split("/")[1];
        var dia  = data.split("/")[0];
        // var dia2  = dia.substring(0,2)
  
        const dataFormatada = ano + '-' + ("0"+mes).slice(-2) + '-' + dia;
  
        const dias = this.verificarDias(dataFormatada)
        
        if((store.state.numeroEndereco == 127 || store.state.numeroEndereco == '127') || (store.state.numeroEndereco == 124 || store.state.numeroEndereco == '124')) {
          if(dias > 90) {
            return "green";
          } else if(dias > 0 && dias <= 90) {
            return "orange";
          } else if(dias <= 0) {
            return "red";
          }
        } else {
          if(dias > 30) {
            return "green";
          } else if(dias > 0 && dias <= 30) {
            return "orange";
          } else if(dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual= new Date().toISOString().substr(0, 10);
      const daterecive= data
      
      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual)
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24))

      return daysOfDiference
    },

  },
};
</script>
